import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { F1IssuersExclusionEditCard } from "./edit_card";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const F1IssuersExclusionCard = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <F1IssuersExclusionEditCard
          id={Number(id)}
          client={Clients.F1_QUANTILIA}
          table_name={Tables.F1_ISSUERS_EXCLUSION}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.F1_QUANTILIA}
          audit_table_name={Tables.F1_ISSUERS_EXCLUSION}
        />
      </div>
    </div>
  );
};
